import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { validStockAnalysisTypes } from "../../../Appconstants";
import { stockLevelAnalysis } from "../../../redux/actions/API/dashboardActions";
import InventoryExtra from "./InventoryExtra";
import { useEffect } from "react";

interface IStockLevelAnalysisItemsProps {
  stockLevelAnalysis: Function;
  stockLevelAnalysisState: any;
  stockLevelAnalysisLoading: boolean;
  companyId: any;
}

const STOCK_ANALYSIS_LABEL_MAP: Record<string, string> = {
  ideal: "Ideal",
  min: "Min",
  max: "Max",
};

const StockLevelAnalysisItems: React.FC<IStockLevelAnalysisItemsProps> = ({
  companyId,
  stockLevelAnalysis,
  stockLevelAnalysisState,
  stockLevelAnalysisLoading,
}) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const typeIndexParam = Number(searchParams.get("typeIndex"));
  const hasValidTypeIndex =
    Number.isInteger(typeIndexParam) &&
    typeIndexParam >= 0 &&
    typeIndexParam < validStockAnalysisTypes.length;
  const selectedTypeIndex = hasValidTypeIndex ? typeIndexParam : 0;

  const orderedTypeIndexes = hasValidTypeIndex
    ? [
        selectedTypeIndex,
        ...validStockAnalysisTypes
          .map((_: string, index: number) => index)
          .filter((index: number) => index !== selectedTypeIndex),
      ]
    : validStockAnalysisTypes.map((_: string, index: number) => index);

  const dropdownOptions = orderedTypeIndexes.map((index: number) => {
    const type = validStockAnalysisTypes[index];
    return {
      label: STOCK_ANALYSIS_LABEL_MAP[type] || type,
      value: index,
    };
  });

  useEffect(() => {
    const resolvedType =
      validStockAnalysisTypes[selectedTypeIndex] || validStockAnalysisTypes[0];

    stockLevelAnalysis({
      companyId: Number(companyId),
      type: resolvedType,
    });
  }, [companyId, selectedTypeIndex, stockLevelAnalysis]);

  const handleDropdownChange = (value: string | number) => {
    navigate(`/stockLevelAnalysisItems?typeIndex=${Number(value)}`);
  };

  return (
    <InventoryExtra
      breadcrumbTitle="Stock Level Analysis"
      dropdownOptions={dropdownOptions}
      loading={stockLevelAnalysisLoading}
      selectedValue={selectedTypeIndex}
      handleDropdownChange={handleDropdownChange}
      tableData={stockLevelAnalysisState}
    />
  );
};

const mapStateToProps = (state: any) => ({
  companyId: state.api.login?.data?.companyId,
  stockLevelAnalysisState: state.api.stockLevelAnalysis?.stockLevelAnalysis,
  stockLevelAnalysisLoading: state.api.stockLevelAnalysis?.loading,
});

const mapDispatchToProps = (dispatch: any) => ({
  stockLevelAnalysis: (payload: any) => dispatch(stockLevelAnalysis(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StockLevelAnalysisItems);
